import { makeStyles } from "@material-ui/core";

const useRbTextInputStyles = makeStyles(
  ({ palette: { type, primary, error, grey, custom } }) => ({
    root: (props) => ({
      boxSizing: "border-box",
      minHeight: 32,
      marginTop: "0 !important",
      padding: "2px 8px",
      border: `1px solid ${custom.border["400"]}`,
      borderRadius: props.rounded ? 16 : 4,
      backgroundColor: custom.high,
      "&.MuiInputBase-adornedEnd > .MuiInputAdornment-root": {
        width: 32,
      },
      "&.MuiInputBase-multiline": {
        padding: 0,
      },
    }),
    disabled: {
      opacity: 0.48,
    },
    focused: {
      border: `1px solid ${primary.main} !important`,
      boxShadow: `0 0 4px ${primary.main}`,
    },
    error: {
      border: `1px solid ${error.main} !important`,
      "&.Mui-focused": {
        boxShadow: `0 0 ${type === "dark" ? 8 : 4}px ${error.main}`,
      },
    },
    marginDense: {
      minHeight: 28,
    },
    input: {
      boxSizing: "border-box",
      minHeight: 26,
      "&.MuiInput-input.MuiInput-input.MuiInput-input::placeholder": {
        opacity: "1 !important",
        color: grey[400],
        fontStyle: "oblique",
      },
    },
    inputMultiline: {
      padding: "4px 8px",
    },
  })
);

export default useRbTextInputStyles;
